/* eslint-disable no-restricted-globals, no-unused-vars */
// ─────────────────────────────────────────────────────────────────────────
// SERGA // PERSONAL OS — data layer
// Real content lifted from the Serga BA screenshots, plus the two new zones
// (Finances, Travel) rooted in the same real threads.
// ─────────────────────────────────────────────────────────────────────────

export const PROFILE = {
  name: 'SERGA',
  handle: 'serge.ba',
  role: 'PERSONAL OPERATING SYSTEM',
};

// "Today" the dashboard orients around. Matches the screenshots' timeframe.
export const TODAY = new Date(2026, 4, 31); // 31 May 2026

// PROJECTS is the static fallback / dev fixture. At runtime SergaOS replaces it
// with live data from the /projects API via setLiveProjects() before boot().
export let PROJECTS = [
  {
    id: 'czech',
    title: 'Czech Citizenship Application',
    status: 'Active',
    priority: 'High',
    due: '2026-05-01',
    tag: 'CIT-01',
    desc: 'Naturalisation track. Language exemption strategy confirmed; civics exam booked as fallback; documents being gathered across CZ + BiH.',
    next: "Take civics exam 30/05 (tomorrow, paid) as fallback. Language exemption: contact MV ČR odbor st. občanství directly (obcanmat@mv.gov.cz / 974 817 438 Mon&Wed / DS) — they decide it, not ÚMČ/ÚJOP. Confirmed: exemption covers BOTH exams; test is 'Czech as language of instruction' not graded subject, so 5th-grade gap is moot — 3 vysvědčení suffice. Then: Bosnia trip ~8 Jun (birth cert + criminal record + apostille); apostille+translate birth cert; chase MV přehled pobytů.",
    tasks: [
      { t: 'Book + sit civics exam (fallback)', s: 'In Progress' },
      { t: 'Contact MV ČR re language exemption decision', s: 'To Do' },
      { t: 'Gather 3 vysvědčení (proof of CZ-language instruction)', s: 'Done' },
      { t: 'Bosnia: birth cert + criminal record + apostille', s: 'To Do' },
      { t: 'Apostille + translate birth certificate', s: 'To Do' },
      { t: 'Chase MV přehled pobytů', s: 'To Do' },
    ],
    artifacts: ['Document Checklist', 'MV ČR Contact Card', 'Exemption Legal Notes', 'Bosnia Trip Plan'],
  },
  {
    id: 'elevio',
    title: 'Elevio.gg (ex-TGU) — Technical Advisory',
    status: 'Active',
    priority: 'Medium',
    due: null,
    tag: 'ADV-02',
    desc: 'Technical advisory on a games-education platform. 5-stack architecture and a Sept 2027 timeline agreed at the 14 May workshop.',
    next: "Workshop 14 May went well. 5-stack architecture + Sept 2027 timeline agreed. Reviewed Darko's 3 docs (2 courses + Architecture: 7 primitives on Godot 4 + React/Next) in art_2OlMfFomzlf9. Drive before Cookielab quote: (1) send review to Darko; (2) elevate curriculum schema to month-1; (3) sketch telemetry stack; (4) decide AI-character runtime; (5) Godot WebGL cold-load spike; (6) IP/ownership talk; (7) reframe Cookielab scope as primitives+shell+hub.",
    tasks: [
      { t: 'Send architecture review to Darko', s: 'To Do' },
      { t: 'Elevate curriculum schema to month-1', s: 'To Do' },
      { t: 'Sketch telemetry stack', s: 'To Do' },
      { t: 'Decide AI-character runtime', s: 'To Do' },
      { t: 'Godot WebGL cold-load spike', s: 'To Do' },
      { t: 'IP / ownership conversation', s: 'To Do' },
      { t: 'Reframe Cookielab scope (primitives + shell + hub)', s: 'To Do' },
    ],
    artifacts: ['Architecture: 7 Primitives', 'Curriculum Schema', 'Cookielab Scope Draft', 'Workshop 14 May Notes'],
  },
  {
    id: 'amazon',
    title: 'Post-Amazon Transition',
    status: 'Active',
    priority: 'High',
    due: '2026-05-03',
    tag: 'TRN-03',
    desc: 'Winding down employment cleanly: ÚP registration, state health insurance, documents from Amazon, then unemployment support filing.',
    next: 'All immediate ÚP actions done. Job seeker registration filed 4 May (ZAM-0023312256, spis. zn. 65682-26-A); responded same-day to ÚP výzva 6 May with termination agreement + zápočtový list. Now waiting on: (1) ÚP rozhodnutí o zařazení do evidence via Jenda, (2) VZP confirmation of state-paid health insurance by 12 May (calendar reminder set), (3) hard copy zápočtový list in post, (4) POZP + ELDP from Amazon ~early July (calendar reminder 13 Jul). Then file Žádost o podporu v nezaměstnanosti.',
    tasks: [
      { t: 'File job-seeker registration (ZAM-0023312256)', s: 'Done' },
      { t: 'Respond to ÚP výzva (termination + zápočtový list)', s: 'Done' },
      { t: 'Await ÚP rozhodnutí o zařazení (via Jenda)', s: 'In Progress' },
      { t: 'VZP confirmation of state-paid health insurance', s: 'In Progress' },
      { t: 'Receive hard-copy zápočtový list', s: 'To Do' },
      { t: 'POZP + ELDP from Amazon (~early July)', s: 'To Do' },
      { t: 'File Žádost o podporu v nezaměstnanosti', s: 'To Do' },
    ],
    artifacts: ['ÚP Registration Receipt', 'Termination Agreement', 'Calendar Reminders', 'VZP Correspondence'],
  },
  {
    id: 'minska',
    title: 'Minská Apartment — Rental Management',
    status: 'Active',
    priority: 'High',
    due: null,
    tag: 'PROP-04',
    desc: 'Co-owned apartment with ex-wife Amila at Minská, Prague. Rented out to cover mortgage. Managed tenant transition from Mr. Foster (moved out Jan 14, 2026) to new tenant Mr. Kamenský. Ongoing: electricity tariff switch (D01d → D57d via Vemex), property maintenance, contract finalization. Agent: Dana Rumanová (RE/MAX Harmony). Electricity supplier: Vemex Energie a.s. (contact: Kateřina Štefková, info@vemexenergie.cz, 800 400 420).',
    next: 'Await reply from HPELEKTRON (kancelar@hpelektron.cz) re D57d revision — email sent 26/03/2026. If no reply by ~29/03, call them: +420 222 988 993. Note: Křenek (ELEKTROŠTIKA) is in hospital, unavailable ~2 months.',
    tasks: [
      { t: 'Finalize new tenant contract with Mr. Kamenský', s: 'Done' },
      { t: 'Complete electricity tariff switch (D01d → D57d)', s: 'In Progress' },
      { t: "Return Mr. Foster's security deposit", s: 'Done' },
      { t: 'Fix leaking electric heated towel rail', s: 'Done' },
      { t: 'Arrange window/door energy efficiency assessment', s: 'To Do' },
      { t: 'Find and hire handyman for maintenance work', s: 'Done' },
      { t: 'Coordinate radiator measurements and delivery', s: 'Done' },
    ],
    artifacts: ['Key Contacts', 'Financial Summary', 'Completed Work Log', 'Local Files Index', 'Draft: Email to Vemex re SOP signature + electrician', 'Call Script: ELEKTROŠTIKA — D57d revision at Minská'],
  },
  {
    id: 'finances-proj',
    title: 'Personal Finances & Investments',
    status: 'Active',
    priority: 'Medium',
    due: null,
    tag: 'FIN-05',
    desc: 'Build a complete financial picture before income stops post-Amazon: cut waste, model the runway, confirm benefits.',
    next: 'Before May: audit subscriptions/costs for cuts, estimate variable expenses (food, transport, etc.), and check unemployment benefits eligibility. Goal: complete financial picture before income stops.',
    tasks: [
      { t: 'Audit subscriptions for cuts', s: 'In Progress' },
      { t: 'Estimate variable expenses (food, transport)', s: 'To Do' },
      { t: 'Check unemployment-benefit eligibility', s: 'In Progress' },
      { t: 'Model post-income runway', s: 'To Do' },
    ],
    artifacts: ['Subscription Audit', 'Runway Model', 'Benefits Eligibility Notes'],
  },
];

// ── Finances zone — rooted in the real threads (runway before income stops) ──
export const FINANCE = {
  headline: 'Runway before income stops',
  note: 'Estimates — auditing in progress. Edit live as numbers firm up.',
  metrics: [
    { label: 'LIQUID RUNWAY', value: '— mo', hint: 'pending burn estimate' },
    { label: 'MONTHLY BURN (est.)', value: '— ', hint: 'food + transport + fixed' },
    { label: 'MINSKÁ: RENT vs MORTGAGE', value: 'covers', hint: 'Kamenský tenancy' },
    { label: 'ÚP SUPPORT', value: 'pending', hint: 'after evidence decision' },
  ],
  threads: [
    { t: 'Subscription audit', s: 'In Progress', note: 'cut recurring waste' },
    { t: 'Variable-expense estimate', s: 'To Do', note: 'food, transport' },
    { t: 'Unemployment support (ÚP)', s: 'Pending', note: 'eligibility + filing' },
    { t: 'Investments review', s: 'To Do', note: 'rebalance for low-income window' },
  ],
};

// ── Investments — the portfolio view under FINANCES ───────────────────────
// `period` is the live selection the period selector writes to; the card reads
// it so hero + holdings always reflect the same window. This is the static
// fallback / dev fixture; at runtime SergaOS replaces it with live data from
// /finance/investments via setLiveInvestments() (the fetcher Lambda prices the
// portfolio every 2h). Per-holding `d` = % change for each period.
export let INVEST = {
  currency: '€',
  total: 86420,                 // current total portfolio value
  asof: '31 May 2026 · 17:40 CET',
  period: '1M',                 // live selection (mutated by the selector)
  periods: ['1D', '1W', '1M', '1Y', 'ALL'],
  // portfolio-level move for each window — { abs €, pct % }
  delta: {
    '1D':  { abs:  363, pct:  0.42 },
    '1W':  { abs: -1031, pct: -1.18 },
    '1M':  { abs:  3035, pct:  3.64 },
    '1Y':  { abs: 15640, pct: 22.10 },
    'ALL': { abs: 23430, pct: 37.20 },
  },
  // holdings — value is current €; d = % change per window
  holdings: [
    { sym: 'AMZN', name: 'Amazon.com',            qty: 142,    value: 24180,
      d: { '1D': 0.7, '1W': -1.9, '1M': 5.2, '1Y': 24.8, 'ALL': 38.4 } },
    { sym: 'VWCE', name: 'Vanguard FTSE All-World', qty: 178,  value: 21640,
      d: { '1D': 0.3, '1W': -0.8, '1M': 2.9, '1Y': 17.2, 'ALL': 29.6 } },
    { sym: 'CSPX', name: 'iShares Core S&P 500',  qty: 21,     value: 13900,
      d: { '1D': 0.4, '1W': -0.9, '1M': 3.1, '1Y': 18.6, 'ALL': 31.2 } },
    { sym: 'NVDA', name: 'NVIDIA',                qty: 58,     value:  9820,
      d: { '1D': 1.6, '1W': -3.4, '1M': 8.7, '1Y': 41.5, 'ALL': 72.0 } },
    { sym: 'MSFT', name: 'Microsoft',             qty: 14,     value:  7450,
      d: { '1D': 0.5, '1W': -1.1, '1M': 3.8, '1Y': 21.0, 'ALL': 33.5 } },
    { sym: 'BTC',  name: 'Bitcoin',               qty: 0.071,  value:  6180,
      d: { '1D': -1.2, '1W': 4.6, '1M': -6.8, '1Y': 34.0, 'ALL': 58.0 } },
    { sym: 'CASH', name: 'Cash · EUR',            qty: null,   value:  3250,
      d: { '1D': 0, '1W': 0, '1M': 0, '1Y': 0, 'ALL': 0 } },
  ],
};

// ── Budget — monthly spend vs budget under FINANCES ───────────────────────
// Static fallback / dev fixture; SergaOS replaces it with live /finance/budget
// data via setLiveBudget() before boot(). Read-only — edited by importing a
// bank CSV through Claude Code (categorize-statement skill), not the web UI.
export let BUDGET = {
  month: '2026-05',
  currency: 'CZK',
  months: ['2026-05'],
  totals: { spent: 0, income: 0, net: 0 },
  categories: [
    { id: 'dining', label: 'Dining & Cafés', group: 'Lifestyle', budget: 0, spent: 0 },
    { id: 'groceries', label: 'Groceries', group: 'Living', budget: 0, spent: 0 },
  ],
  transactions: [],
};

// ── FEED · Today's Focus — agent-curated attention board (upper tray section) ─
// Static fallback / dev fixture. At runtime SergaOS replaces it with the live
// /feed payload (feed/focus.json in S3, written a few times/day by a local
// Claude Code agent) via setLiveFocus(). `rev` is the agent's push id —
// per-item dismissals in the tray key off it, so a new rev re-seeds the board.
// `updatedAt` is ISO; the tray renders a relative "UPD …" stamp from it.
// Each item may carry an optional `description` — the fuller body the FEED
// detail card renders when the item is selected (falls back to a placeholder).
export let FOCUS = {
  rev: '2026-05-31T0800',
  period: 'WK 31 MAY → 6 JUN',
  curator: 'SRG-AGENT',
  updatedAt: '2026-05-31T08:00:00Z',
  items: [
    { id: 'evt:czech:civics-fallback', type: 'event', title: 'Civics exam — fallback sitting',
      meta: '30 MAY · 09:00 · ÚJOP', src: 'czech', urgent: true,
      description: 'Backup civics sitting at ÚJOP if the exemption is refused. Bring ID + the registration slip; the slot is held until 09:00. Cancel only once MV ČR confirms the language-exemption decision below.' },
    { id: 'email:mvcr:exemption-decision', type: 'email', title: 'MV ČR — language-exemption decision',
      meta: 'obcanmat@mv.gov.cz · UNREAD', src: 'czech',
      description: 'The three vysvědčení argument went in; this reply should say whether the graded-subject exemption is granted. If granted, the civics fallback can be cancelled. Read before the 30 MAY slot.' },
    { id: 'task:elevio:ADV-02', type: 'task', title: 'Send architecture review to Darko',
      meta: 'Elevio · ADV-02', src: 'elevio',
      description: 'Finish the architecture review doc and send to Darko — the Godot/React shell boundary and the telemetry schema are the two open points blocking the next milestone.' },
    { id: 'evt:amazon:vzp-insurance', type: 'event', title: 'VZP — confirm state health insurance',
      meta: 'DUE 12 MAY · reminder set', src: 'amazon',  urgent: true,
      description: 'Confirm the state health-insurance bridge now that the Amazon contract has ended. Without VZP confirmation there is a coverage gap; the zápočtový list is already filed.' },
    { id: 'email:minska:hpelektron-d57d', type: 'email', title: 'HPELEKTRON — D57d revision reply',
      meta: 'kancelar@hpelektron.cz · AWAITING', src: 'minska',
      description: 'Awaiting HPELEKTRON’s reply on the D57d revision for the Minská flat. Chase if nothing lands by end of week — it gates the Smíchov handover.' },
    { id: 'note:finances:subscription-audit', type: 'note', title: 'Audit subscriptions before income stops',
      meta: 'Finances · FIN-05', src: 'finances-proj',
      description: 'List every recurring charge and cut what isn’t load-bearing before the salary stops. Cross-check against the budget month import; target the highest CZK/month first.' },
    { id: 'evt:czech:bosnia-run', type: 'event', title: 'Bosnia document run',
      meta: '~8 JUN · birth cert + criminal record', src: 'czech',
      description: 'Collect the birth certificate + criminal record in BiH, then apostille both and translate the birth cert. Feeds the citizenship file (CIT-01). See the Travel zone for the trip plan.' },
  ],
};

// ── FEED · Stream — Mastodon home timeline (lower tray section) ────────────
// Static fallback / dev fixture (a few of the operator's own posts). At runtime
// SergaOS replaces it with the live /feed `stream` payload via setLiveStream():
// posts from the accounts the Mastodon account follows (incl. federating Threads
// accounts). `handle` labels the section; live items carry a per-post `author`.
// Fixture items use `agoMin`; live items carry an ISO `createdAt`.
export let STREAM = {
  handle: '@serge.ba',
  items: [
    { id: 't1', agoMin: 18, likes: 12, replies: 2, permalink: '#',
      text: 'Three vysvědčení beat a graded subject — turns out the 5th-grade gap was never the blocker. Bureaucracy rewards reading the statute, not the form.' },
    { id: 't2', agoMin: 72, likes: 31, replies: 6, permalink: '#',
      text: 'Godot 4 + a thin React/Next shell is a genuinely good stack for games-education. Seven primitives carry more than I expected.' },
    { id: 't3', agoMin: 140, likes: 8, replies: 1, permalink: '#',
      text: 'Building my own personal OS as a spatial field instead of a list of tabs. Everything I manage is a node you fly to. Strangely calming.' },
    { id: 't4', agoMin: 260, likes: 44, replies: 9, permalink: '#',
      text: 'Last week at Amazon wrapped. The cleanest exits are the boring ones: zápočtový list filed, ÚP registered, insurance bridged.' },
    { id: 't5', agoMin: 410, likes: 17, replies: 3, permalink: '#',
      text: 'Telemetry-first curriculum design: if you can’t see where a learner stalls, you’re guessing at pedagogy. Month-1 schema or nothing.' },
  ],
};

// ── Travel zone — live trips (travel/<slug>.json via /travel). ──────────────
// Static fallback / dev fixture in the structured trip shape; at runtime
// SergaOS replaces it with the live list via setLiveTravel(). Trips only (no
// home base) — Prague is implicit as the origin of every transport leg.
export const TRAVEL = [
  {
    id: 'bosnia-2026-06',
    destination: 'Bosnia & Herzegovina',
    title: 'BiH document run',
    status: 'planned',
    dates: { start: '2026-06-08', end: '2026-06-15', flexible: true },
    purpose: 'Collect birth certificate + criminal record, then apostille both. Feeds Czech citizenship (CIT-01).',
    linkedProject: 'czech',
    transport: [
      { mode: 'flight', from: 'PRG', to: 'SJJ', date: '2026-06-08', ref: null, status: 'idea' },
    ],
    accommodation: [
      { name: null, city: 'Sarajevo', checkIn: '2026-06-08', checkOut: '2026-06-15', ref: null, status: 'idea' },
    ],
    checklist: [
      { label: 'Birth certificate', done: false },
      { label: 'Criminal record', done: false },
      { label: 'Apostille both', done: false },
      { label: 'Translate birth cert', done: false },
    ],
    notes: '',
  },
];

// ── VITALS zone (ZN-05) — Mind + Body ──────────────────────────────────────
// MIND: a 1–5 daily check-in that renders AS a mental-health bar, with an
// optional one-line journal per day accumulating as dated history. `today` is
// null until the operator taps a level. Live + S3-backed (PR C wires the API);
// for now a fixture the SHELL/store edits and persists to localStorage.
// BODY: physical vitals as ambient slow-moving gauges. MOCKED — the real values
// arrive later from a phone-side Apple Health exporter writing vitals/body.json.
export const VITALS = {
  mind: {
    scale: 5,
    today: null,                         // 1..5 once tapped today; null = not logged
    labels: ['', 'DEPLETED', 'LOW', 'STEADY', 'GOOD', 'PEAK'],
    note: '',                            // today's one-line entry (optional)
    // dated history, most-recent first. `n` = the day's journal line (may be '').
    log: [
      { d: '2026-05-30', v: 4, n: 'Civics exam booked as fallback. Weight off the chest.' },
      { d: '2026-05-29', v: 3, n: 'ÚP paperwork all day. Fog, but moving.' },
      { d: '2026-05-28', v: 4, n: '' },
      { d: '2026-05-27', v: 2, n: 'Insurance-gap anxiety. Couldn’t settle.' },
      { d: '2026-05-26', v: 3, n: '' },
      { d: '2026-05-25', v: 4, n: 'Sunday. Coffee, a scene compiling in the background.' },
      { d: '2026-05-24', v: 5, n: 'Workshop momentum carried the whole day.' },
      { d: '2026-05-23', v: 3, n: '' },
      { d: '2026-05-22', v: 4, n: 'Direct line to MV ČR finally rang through.' },
    ],
  },
  body: {
    // each gauge: a value within [min,max], a soft `target` marker, and a 7-point
    // `trend` (oldest→newest) drawn as a sparkline. `invert` = lower is better.
    gauges: [
      { id: 'sleep', label: 'SLEEP', glyph: 'v-sleep', value: 6.8, unit: 'h',
        min: 4, max: 9, target: 7.5, hint: '7-night average',
        trend: [6.2, 7.1, 6.6, 7.4, 6.0, 7.0, 6.8] },
      { id: 'steps', label: 'STEPS', glyph: 'v-steps', value: 7420, unit: '',
        min: 0, max: 12000, target: 8000, hint: 'today · 18:00',
        trend: [9100, 5400, 8800, 6200, 10300, 7000, 7420] },
      { id: 'rhr', label: 'RESTING HR', glyph: 'heart', value: 54, unit: 'bpm',
        min: 40, max: 80, target: 56, invert: true, hint: 'overnight low',
        trend: [57, 55, 58, 54, 53, 56, 54] },
    ],
    workoutsWk: 3,                       // sessions this week (ambient context)
  },
};

// ── CAPTURE zone (ZN-06) — one fast inbox ──────────────────────────────────
// A thought goes in with two seconds of effort; later it's kept as a note,
// routed to a project (tagged with `route` = projectId), or discarded.
// `state`: inbox | note. `at` is an ISO-ish stamp; the card renders a relative
// age from it. Live + S3-backed in PR C; fixture + localStorage draft for now.
export const CAPTURE = {
  items: [
    { id: 'q1', state: 'inbox', at: '2026-05-31T17:12', route: null,
      text: 'Ask MV ČR if the exemption letter needs a wet signature or DS is fine' },
    { id: 'q2', state: 'inbox', at: '2026-05-31T15:40', route: null,
      text: 'Telemetry stack — look at PostHog vs self-hosted Plausible for Elevio' },
    { id: 'q3', state: 'inbox', at: '2026-05-31T11:05', route: null,
      text: 'Cancel the second cloud-storage subscription, only using one' },
    { id: 'q4', state: 'note', at: '2026-05-30T20:18', route: 'czech',
      text: '3 vysvědčení are enough — test is “Czech as language of instruction”, not a graded subject' },
    { id: 'q5', state: 'note', at: '2026-05-29T09:30', route: null,
      text: 'Runway model is a forecast, not a verdict. Update weekly, panic never.' },
    { id: 'q6', state: 'inbox', at: '2026-05-28T22:47', route: null,
      text: 'Godot WebGL cold-load — try a warm cache + splash to mask the 2s' },
  ],
};

// ── SYSTEM zone (ZN-07) — homelab ops console ──────────────────────────────
// One node per self-hosted Raspberry Pi: service health (up/down) + host vitals
// as the same bar() gauges as Body. Nodes report via heartbeats — `beatEvery`
// is the expected interval (s); a node silent past `staleAt` renders STALE, past
// `deadAt` renders DOWN (dead-man's switch). Real telemetry is machine-written
// to S3 by a Pi-side uploader (PR C reads it via GET /system, where the server
// computes `sinceBeat` from `lastBeat` vs now). For now this is a hand-seeded
// MOCK of the actual homelab: 2 Pis running Samba, Sonarr, Radarr, Transmission,
// a Minecraft server, and Pi-hole.
export const SYSTEM = {
  staleAt: 14,                           // seconds silent → STALE (amber)
  deadAt: 30,                            // seconds silent → DOWN (red)
  nodes: [
    {
      id: 'core', name: 'CORE', code: 'PI-01', host: 'Raspberry Pi 4B · 4GB',
      role: 'Network + file core', ip: '10.0.0.2', cores: 4, beatEvery: 8, sinceBeat: 2,
      services: [
        { name: 'Pi-hole', port: 'dns/53', up: true },
        { name: 'Samba', port: ':445', up: true },
      ],
      vitals: { temp: 47, load: 0.6, disk: 41, mem: 52 }, uptimeH: 3142,
    },
    {
      id: 'media', name: 'MEDIA', code: 'PI-02', host: 'Raspberry Pi 4B · 8GB',
      role: 'Media automation + game', ip: '10.0.0.3', cores: 4, beatEvery: 8, sinceBeat: 3,
      services: [
        { name: 'Sonarr', port: ':8989', up: true },
        { name: 'Radarr', port: ':7878', up: true },
        { name: 'Transmission', port: ':9091', up: true },
        { name: 'Minecraft', port: ':25565', up: true },
      ],
      vitals: { temp: 58, load: 1.4, disk: 64, mem: 67 }, uptimeH: 642,
    },
  ],
};

function computeZones() {
  return [
    {
      id: 'projects', label: 'PROJECTS', code: 'ZN-01',
      sub: PROJECTS.length + ' active', children: PROJECTS.map(p => p.id),
    },
    {
      id: 'finances', label: 'FINANCES', code: 'ZN-02',
      sub: 'runway · investments · budget', children: ['fin-runway', 'fin-invest', 'fin-budget'],
    },
    {
      id: 'travel', label: 'TRAVEL', code: 'ZN-03',
      sub: TRAVEL.length + ' places', children: TRAVEL.map(t => 'tr-' + t.id),
    },
    {
      // remote home node — Lokale (cloud.serga.ba). A doorway zone: no child
      // cards; drilling in blooms the CLOUD portal (iframe) open over the field.
      id: 'cloud', label: 'CLOUD', code: 'ZN-04',
      sub: 'home node · media + files', children: [],
    },
    {
      id: 'vitals', label: 'VITALS', code: 'ZN-05',
      sub: 'mind · body', children: ['vi-mind', 'vi-body'],
    },
    {
      id: 'capture', label: 'CAPTURE', code: 'ZN-06',
      sub: 'quick inbox', children: ['cap-inbox'],
    },
    {
      id: 'system', label: 'SYSTEM', code: 'ZN-07',
      sub: SYSTEM.nodes.length + ' nodes', children: SYSTEM.nodes.map(n => 'sys-' + n.id),
    },
  ];
}

// ZONES is reassigned (live binding) whenever live projects arrive, so the
// PROJECTS zone's count/children reflect the real data.
export let ZONES = computeZones();

// User-created zones (mock CMS, edited via the SERGA SHELL). Empty until the
// shell/store layer populates it; mutated in place so live bindings stay valid.
export let EXTRA_ZONES = [];

// Replace the static project list with live data (called before boot()).
// Ignored if the live list is empty so we keep the fallback fixture.
export function setLiveProjects(projects) {
  if (Array.isArray(projects) && projects.length) {
    PROJECTS = projects;
    ZONES = computeZones();
  }
}

// Replace the fixture trips with the live /travel list (called before boot()
// and from the change-feed). TRAVEL is a const array, so mutate in place (the
// SHELL/store read the same binding) and recompute zones for the new count.
export function setLiveTravel(trips) {
  if (Array.isArray(trips) && trips.length) {
    TRAVEL.splice(0, TRAVEL.length, ...trips);
    ZONES = computeZones();
  }
}

// Replace the mocked portfolio with the live /finance/investments payload.
// Ignored when null/pending so we keep the fallback fixture.
export function setLiveInvestments(inv) {
  if (inv && Array.isArray(inv.holdings) && inv.holdings.length) {
    INVEST = inv;
  }
}

// Replace the fixture with the live /finance/budget payload. Ignored when
// null/pending so we keep the fallback fixture.
export function setLiveBudget(b) {
  if (b && Array.isArray(b.categories)) {
    BUDGET = b;
  }
}

// Replace the fixture board with the live /feed focus payload. Ignored when
// null/pending so we keep the fallback fixture.
export function setLiveFocus(f) {
  if (f && !f.pending && Array.isArray(f.items)) {
    FOCUS = f;
  }
}

// Replace the fixture stream with the live /feed stream (Mastodon timeline).
// Ignored when null/pending/empty so we keep the fallback fixture.
export function setLiveStream(s) {
  if (s && !s.pending && Array.isArray(s.items) && s.items.length) {
    STREAM = s;
  }
}

// VITALS / CAPTURE / SYSTEM are `export const` objects edited in place (the
// SHELL/store read the same binding), so the live setters mutate in place
// rather than reassigning — keeping live ESM bindings in cards.js valid. PR C
// wires these to GET /vitals · /capture · /system. Ignored when null/pending.
export function setLiveVitals(v) {
  if (v && !v.pending && (v.mind || v.body)) {
    if (v.mind) VITALS.mind = v.mind;
    if (v.body) VITALS.body = v.body;
  }
}

export function setLiveCapture(c) {
  if (c && !c.pending && Array.isArray(c.items)) {
    CAPTURE.items.splice(0, CAPTURE.items.length, ...c.items);
  }
}

export function setLiveSystem(s) {
  if (s && !s.pending && Array.isArray(s.nodes)) {
    SYSTEM.nodes.splice(0, SYSTEM.nodes.length, ...s.nodes);
    if (typeof s.staleAt === 'number') SYSTEM.staleAt = s.staleAt;
    if (typeof s.deadAt === 'number') SYSTEM.deadAt = s.deadAt;
    ZONES = computeZones();   // node count drives the SYSTEM zone sub/children
  }
}
